import { useEffect } from "react";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LEGAL } from "@/config/legal";
import { TRIAL_DAYS } from "@/config/pricing";

const FAQ_ITEMS = [
  {
    q: "How long is the free trial?",
    a: `The free trial is ${TRIAL_DAYS} days. No credit card required to start.`,
  },
  {
    q: "How do I get an invoice?",
    a: "Invoices are sent by email after each payment. You can also request them from the billing section in Settings or by contacting support.",
  },
  {
    q: "What about privacy and my data?",
    a: "We process data in accordance with our Privacy Policy and applicable law. You can request access, correction, or deletion by contacting our DPO.",
  },
  {
    q: "Can I export my data?",
    a: "Yes. You can export leads and pipeline data from the app. For a full data export, contact support.",
  },
  {
    q: "How do I cancel?",
    a: "You can cancel your subscription from Settings. Your data is retained for a period after cancellation so you can re-activate or export it.",
  },
];

export default function FaqPage() {
  useEffect(() => {
    document.title = "FAQ | Decision Sales OS";
  }, []);

  return (
    <PublicLayout showCookieBanner={false}>
      <h1 className="text-3xl font-semibold tracking-tight mb-4">Frequently asked questions</h1>
      <p className="text-muted-foreground mb-8">
        Trial, billing, privacy, export, and cancellation.
      </p>

      <Card>
        <CardHeader>
          <CardTitle>Common questions</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {FAQ_ITEMS.map((item, i) => (
            <div key={i}>
              <p className="font-medium text-foreground">{item.q}</p>
              <p className="text-muted-foreground text-sm mt-1">{item.a}</p>
            </div>
          ))}
          <p className="text-sm text-muted-foreground pt-4 border-t border-border/40">
            Still have questions? Contact us at{" "}
            <a href={`mailto:${LEGAL.supportEmail}`} className="text-primary hover:underline">
              {LEGAL.supportEmail}
            </a>{" "}
            or see our{" "}
            <a href="/privacy" className="text-primary hover:underline">Privacy</a> and{" "}
            <a href="/terms" className="text-primary hover:underline">Terms</a>.
          </p>
        </CardContent>
      </Card>
    </PublicLayout>
  );
}
